<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4iThoA/tc-custom/9781781263488.jpg?1700308622286" alt="This image is the cover for the book Painting Perspective, Depth & Distance in Watercolour"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Painting Perspective, Depth & Distance in Watercolour
      </h1>
      <p class="bookDescription body article font2">
        <b>The master watercolourist shares essential techniques for adding depth and realism to your watercolour paintings in this accessible guide.</b><br/><br/>In <i>Perspective Depth and Distance</i>, watercolourist and teacher Geoff Kersey demonstrates how to use line, tone, colour, and detail to create captivating landscapes. With this practical guide, you will learn to capture the beauty of mist-draped mountains and dense woodlands. You will also learn to paint boats, buildings, and natural features that seem to recede into the distance. <br/><br/>This volume includes seven step-by-step projects with inspiration and ideas for your own original landscapes. It also features techniques for linear and aerial perspective.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Geoff Kersey
      </h2>
      
      <p class="authorDescription body article">Geoff Kersey is an experienced watercolourist and is much in demand as a teacher and demonstrator. He lives and works in Derbyshire, where he has a studio, and he exhibits extensively. He has made many watercolour DVDs, contributes to various art publications and has written many bestselling watercolour books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Search Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b30586d6